import React from 'react';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@app/components/products/anonymize-pro/components/ui/select';
import { SelectProps } from '@radix-ui/react-select';

interface LocationSelectorProps extends SelectProps {
    label: string;
    contents: Array<string>;
    isRequired?: boolean;
}

function InputSelector({ label, contents, value, onValueChange, isRequired }: LocationSelectorProps) {
    return (
        <div className="flex flex-col gap-2">
            <label className="anonymize-p3 text-black-700">
                {label}
                {!!isRequired && <span className="text-red-500">*</span>}
            </label>
            <Select onValueChange={onValueChange} value={value}>
                <SelectTrigger className="w-full">
                    <SelectValue placeholder="Select" className="anonymize-p4 placeholder:text-black-400" />
                </SelectTrigger>
                <SelectContent>
                    <SelectGroup className="bg-white">
                        {contents.map((location) => (
                            <SelectItem className="hover:bg-black-300" key={location} value={location}>
                                {location}
                            </SelectItem>
                        ))}
                    </SelectGroup>
                </SelectContent>
            </Select>
        </div>
    );
}

export default InputSelector;
